import { EditorsChoiceSectionBase } from '../../../dapp-form/sections/EditorsChoiceSectionBase';
import { MediaUploadWithExisting } from '../../MediaUploadWithExisting';
import type { DashboardDetailsInputChangeEvent, FormState } from '../types';

interface EditorsChoiceSectionProps {
  formData: FormState;
  resolvedEditorsChoiceGraphicUrl: string | null;
  onInputChange: (event: DashboardDetailsInputChangeEvent) => void;
  onSingleFileChange: (
    fieldName: 'dappIcon' | 'banner' | 'editorsChoiceGraphic',
    file: File | null,
  ) => Promise<void>;
  onRemoveExistingGraphic: () => void;
}

export function EditorsChoiceSection({
  formData,
  resolvedEditorsChoiceGraphicUrl,
  onInputChange,
  onSingleFileChange,
  onRemoveExistingGraphic,
}: EditorsChoiceSectionProps) {
  return (
    <EditorsChoiceSectionBase
      headline={formData.editorsChoiceHeadline}
      onInputChange={onInputChange}
      graphicField={
        <MediaUploadWithExisting
          name="editorsChoiceGraphic"
          label="Graphic"
          description="To visually represent the dApp"
          dimensions="1200x1200px"
          value={formData.editorsChoiceGraphic}
          existingUrl={resolvedEditorsChoiceGraphicUrl}
          onChange={(file: File | null) =>
            onSingleFileChange('editorsChoiceGraphic', file)
          }
          onRemoveExisting={onRemoveExistingGraphic}
          buttonType="add"
          buttonClassName="text-white"
          placeholderClassName="w-64 h-64"
        />
      }
    />
  );
}
